const fetchAdUser = async (id_token, client_info, session_state, state,code_verifier) => {
  const baseApiUri = process.env.REACT_APP_BACKEND_BASE_URL
  const ttlMinutes = 2 * 60 // two hours
  const response = await fetch(`${baseApiUri}/msid/oauth2/login-redirect`, {
    method: 'POST',
    body: JSON.stringify({
      idToken: id_token,
      client_info,
      session_state,
      state,
      code_verifier
    }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
  const user = await response.json()
  return user
}

export default fetchAdUser
